import React, { Component } from "react";
import { Box, Grid, Stack, Typography } from "@mui/material";

import EqualizerOutlinedIcon from "@mui/icons-material/EqualizerOutlined";

import GroupsOutlinedIcon from "@mui/icons-material/GroupsOutlined";
import BadgeOutlinedIcon from "@mui/icons-material/BadgeOutlined";
import PersonAddAltOutlinedIcon from "@mui/icons-material/PersonAddAltOutlined";
import PaidOutlinedIcon from "@mui/icons-material/PaidOutlined";
import WarningAmberOutlinedIcon from "@mui/icons-material/WarningAmberOutlined";
import InsightsOutlinedIcon from "@mui/icons-material/InsightsOutlined";
import AccountBalanceWalletOutlinedIcon from "@mui/icons-material/AccountBalanceWalletOutlined";


import TrackChangesOutlinedIcon from "@mui/icons-material/TrackChangesOutlined";
import CheckCircleOutlineOutlinedIcon from "@mui/icons-material/CheckCircleOutlineOutlined";
import ErrorOutlineOutlinedIcon from "@mui/icons-material/ErrorOutlineOutlined";

import DashboardHeader from "./DashboardHeader";
import SummaryCard from "../../components/dashlibs/SummaryCard";
import SectionCard from "../../components/dashlibs/SectionCard";
import StatusBadge from "../../components/dashlibs/StatusBadge";
import AlertList from "../../components/dashlibs/AlertList";
import { MockBarChart, MockTrendChart } from "../../components/dashlibs/MockChart";
import { DashboardPageProps } from "./dashboard.types";

import type { ChartTone } from "../../components/charts";
import { DonutChart, AreaTrendChart, BarChart, TreemapChart, StackedBarChart } from "../../components/charts";

const staffingByUnit = [
  { label: "Direction Générale", value: 62, color: "#163A5F" },
  { label: "Opérations", value: 74, color: "#116B43" },
  { label: "DSI", value: 46, color: "#2471A3" },
  { label: "Bingo", value: 58, color: "#D68910" },
  { label: "Bobo", value: 51, color: "#7D3C98" },
];

const recruitmentProgress = [
  { label: "Analystes budget", value: 67, color: "#116B43" },
  { label: "Techniciens maintenance", value: 43, color: "#D68910" },
  { label: "DBA / SI", value: 52, color: "#163A5F" },
  { label: "Support terrain", value: 61, color: "#2471A3" },
];

const staffCostPressure = [
  { label: "Opérations", value: 71, color: "#C0392B" },
  { label: "Bingo", value: 63, color: "#D68910" },
  { label: "DSI", value: 49, color: "#2471A3" },
  { label: "Direction Générale", value: 36, color: "#163A5F" },
];

const headcountTrend = [48, 49, 50, 52, 53, 55, 56, 57, 58, 60, 61, 63];

const hrAlerts = [
  {
    title: "Vacances critiques en maintenance dépôt",
    description: "Le niveau de couverture sur certains postes techniques reste insuffisant.",
    tone: "danger" as const,
  },
  {
    title: "Pression coût sur les effectifs opérationnels",
    description: "Les coûts RH des unités d’exploitation progressent plus vite que prévu.",
    tone: "warning" as const,
  },
  {
    title: "Recrutement budgétaire en bonne progression",
    description: "Les profils finance/budget avancent conformément aux objectifs définis.",
    tone: "success" as const,
  },
];

const roleGapView = [
  { label: "Techniciens maintenance", value: 72, color: "#C0392B" },
  { label: "Analystes budget", value: 41, color: "#163A5F" },
  { label: "Administrateurs SI", value: 53, color: "#2471A3" },
  { label: "Support terrain", value: 47, color: "#D68910" },
];

export default class StaffingDashboard extends Component<DashboardPageProps,any> {
  //const { period,cycle} = sharedFilters;
render(){
  const {userData,dashData,sharedFilters,filterOptions,onFilterChange,onRefresh} = this.props;
  const {meta,sections={},summaryCards=[]} = dashData || {};

  const {staffingByCostCenter={},staffingByRole={},staffingByLevel={},staffingAlerts={}} = sections;

  const iconMap: any = {
    people: <TrackChangesOutlinedIcon />,
    badge: <CheckCircleOutlineOutlinedIcon />,
    warning: <WarningAmberOutlinedIcon />,
    equalizer: <EqualizerOutlinedIcon />,
  }

  return (
    <Box sx={{ p: { xs: 2, md: 3 }, display: "grid", gap: 2.5 }}>
      <DashboardHeader
        title="Dashboard RH & Planification des effectifs"
        subtitle="Vue consolidée des effectifs, du coût du personnel, des recrutements et des écarts de couverture par unité."
        userData={userData}
        sharedFilters={sharedFilters}
        filterOptions={filterOptions}
        onFilterChange={onFilterChange}
        onRefresh={onRefresh}
      />

      <Box sx={{ display: "grid", gridTemplateColumns: "repeat(5, 1fr)", gap: 2 }}>
        {(summaryCards || []).map((card: any) => (
        <SummaryCard
          key={card.code}
          title={card.label}
          value={card.valueFormatted}
          subtitle={card.subtitle}
          delta={card.deltaFormatted}
          tone={card.tone}
          icon={iconMap[card.icon] || <AccountBalanceWalletOutlinedIcon />}
        />
        ))}
      </Box>

      <Box sx={{ display: "grid", gap: 2, gridTemplateColumns: { xs: "1fr", md: "repeat(2, 1fr)" } }}>
        <SectionCard
          title={staffingByCostCenter.title || ""}
          subtitle={staffingByCostCenter.subtitle || ""}
        >
          <StackedBarChart data={(staffingByCostCenter.data || [])} seriesKeys={['planned','actual']} />
        </SectionCard>

        <SectionCard
          title={staffingAlerts.title || ""}
          subtitle={staffingAlerts.subtitle || ""}
        >
          <AlertList items={staffingAlerts.data || []} />
        </SectionCard>
      </Box>

      <Box sx={{ display: "grid", gap: 2, gridTemplateColumns: { xs: "1fr", md: "repeat(2, 1fr)" } }}>
        <SectionCard
          title={staffingByRole.title || ""}
          subtitle={staffingByRole.subtitle || ""}
        >
          <DonutChart data={staffingByRole.data || []} />
        </SectionCard>
        
        <SectionCard
          title={staffingByLevel.title || ""}
          subtitle={staffingByLevel.subtitle || ""}
        >
          <DonutChart data={(staffingByLevel.data || [])} />
        </SectionCard>

        
      </Box>

      {/* <Box
        sx={{
          display: "grid",
          gap: 2,
          gridTemplateColumns: {
            xs: "1fr",
            sm: "repeat(2, 1fr)",
            lg: "repeat(6, 1fr)",
          },
        }}
      >
        <SummaryCard
          title="Effectif planifié"
          value="148"
          subtitle="Cible annuelle"
          delta="FY2025"
          tone="info"
          icon={<GroupsOutlinedIcon />}
        />
        <SummaryCard
          title="Effectif actuel"
          value="123"
          subtitle="Ressources disponibles"
          delta="83,1%"
          tone="success"
          icon={<BadgeOutlinedIcon />}
        />
        <SummaryCard
          title="Postes vacants"
          value="25"
          subtitle="À pourvoir"
          delta="8 critiques"
          tone="warning"
          icon={<PersonAddAltOutlinedIcon />}
        />
        <SummaryCard
          title="Coût RH engagé"
          value="7,2 Md"
          subtitle="Charges personnel"
          delta="61%"
          tone="default"
          icon={<PaidOutlinedIcon />}
        />
        <SummaryCard
          title="Risque effectif"
          value="6"
          subtitle="Unités sensibles"
          delta="Priorité RH"
          tone="danger"
          icon={<WarningAmberOutlinedIcon />}
        />
        <SummaryCard
          title="Couverture globale"
          value="83%"
          subtitle="Plan vs réel"
          delta="+2 pts"
          tone="info"
          icon={<InsightsOutlinedIcon />}
        />
      </Box>

      <Grid container spacing={2}>
        <Grid size={{ xs: 12, lg: 8 }}>
          <SectionCard
            title="Tendance effectifs & recrutement"
            subtitle="Lecture consolidée de l’évolution des effectifs sur la période."
            action={<StatusBadge label="Workforce trend" tone="info" />}
          >
            <MockTrendChart points={headcountTrend} />
          </SectionCard>
        </Grid>

        <Grid size={{ xs: 12, lg: 4 }}>
          <SectionCard
            title="Alertes RH"
            subtitle="Points nécessitant suivi de management."
          >
            <AlertList items={hrAlerts} />
          </SectionCard>
        </Grid>

        <Grid size={{ xs: 12, lg: 4 }}>
          <SectionCard
            title="Couverture par unité"
            subtitle="Niveau de couverture des effectifs par centre/unité."
          >
            <MockBarChart data={staffingByUnit} />
          </SectionCard>
        </Grid>

        <Grid size={{ xs: 12, lg: 4 }}>
          <SectionCard
            title="Avancement recrutement"
            subtitle="Progression sur les profils et postes prioritaires."
          >
            <MockBarChart data={recruitmentProgress} />
          </SectionCard>
        </Grid>

        <Grid size={{ xs: 12, lg: 4 }}>
          <SectionCard
            title="Pression coût RH"
            subtitle="Lecture simplifiée des unités les plus exposées sur les coûts de personnel."
            action={<StatusBadge label="Cost pressure" tone="warning" />}
          >
            <MockBarChart data={staffCostPressure} />
          </SectionCard>
        </Grid>

        <Grid size={{ xs: 12, lg: 6 }}>
          <SectionCard
            title="Lecture management"
            subtitle="Messages clés sur la couverture, les recrutements et les coûts."
          >
            <Stack spacing={1.25}>
              {[
                ["La couverture globale progresse mais reste incomplète", "Plusieurs postes critiques restent vacants, notamment dans les fonctions de maintenance et de terrain."],
                ["Les coûts RH doivent être pilotés par unité", "Les unités opérationnelles sont les plus exposées à la pression sur la masse salariale."],
                ["Le recrutement ciblé améliore la résilience", "Les recrutements sur les fonctions finance, SI et exploitation restent structurants pour la performance globale."],
              ].map(([title, desc]) => (
                <Box
                  key={title}
                  sx={{
                    p: 1.5,
                    borderRadius: "10px",
                    border: "1px solid #E2E8EE",
                    bgcolor: "#FFFFFF",
                  }}
                >
                  <Typography sx={{ fontSize: 13, fontWeight: 800, color: "#17324D" }}>
                    {title}
                  </Typography>
                  <Typography sx={{ fontSize: 13, color: "#66788A", mt: 0.5, lineHeight: 1.65 }}>
                    {desc}
                  </Typography>
                </Box>
              ))}
            </Stack>
          </SectionCard>
        </Grid>

        <Grid size={{ xs: 12, lg: 6 }}>
          <SectionCard
            title="Écarts par rôle"
            subtitle="Lecture simplifiée des profils présentant les plus grands déficits."
          >
            <MockBarChart data={roleGapView} />
          </SectionCard>
        </Grid>
      </Grid> */}
    </Box>
  );
}
}